import React, { useState } from "react";
import { ThreeDots } from "react-loader-spinner";
import { StyledIframe } from "./styled";

const ClarkOverviewIFrame = () => {
  const [loading, setLoading] = useState(true);

  return (
    <div>
      {loading && (
        <ThreeDots
          height="50"
          width="80"
          radius="9"
          color="#262626"
          ariaLabel="three-dots-loading"
          wrapperStyle={{ position: "absolute", left: "50%", top: "50%", transform: "translate(-50%)" }}
          wrapperClassName=""
          visible={true}
        />
      )}
      {/* Link to open the English content as top-level page */}
      <div style={{ marginTop: "1rem", textAlign: "center" }}>
        <p>
          Pokud chcete využít nabídku překladu v prohlížeči,{" "}
          <a href="https://www.clarkmheu.com/en/products?tmpl=component&iframe=true" target="_blank" rel="noopener noreferrer">
            otevřete anglickou verzi
          </a>
          .
        </p>
      </div>

      <StyledIframe lang="en" src="https://www.clarkmheu.com/en/products?tmpl=component&iframe=true" name="Clark Produktkatalog" title="Clark Produktkatalog" onLoad={() => setLoading(false)}>
        <p>Váš prohlížeč nedokáže zobrazit vložené rámce</p>
      </StyledIframe>
    </div>
  );
};

export default ClarkOverviewIFrame;
